export default "__VITE_ASSET__450e02f9__"